import styled from "styled-components";

export const DetailInfoIcon = styled.svg`
  transition: transform 0.1s ease-out;
  &:hover {
    transform: scale(1.25);
  }
  &:active {
    transform: scale(1);
  }
`;
